export enum KeyCodes {
  ESCAPE = 'Escape',
  BACKSPACE = 'Backspace',
  DELETE = 'Delete',

  // Route design
  KEY_D = 'KeyD',
  KEY_E = 'KeyE',
  KEY_I = 'KeyI',
  KEY_M = 'KeyM',
  KEY_O = 'KeyO',
  KEY_P = 'KeyP',
  KEY_S = 'KeyS',
  KEY_Y = 'KeyY',
  KEY_Z = 'KeyZ',
}
